module.exports = __webpack_public_path__ + "img/logo_linaware.79ff6ba8.png";